import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 className="project-heading">
               <span className="purple"> </span>  ABOUT MYSELF
            </h1>
            <p className="home-about-body">
            Hlo World! 👋 I'm Meenu Katariya, a Software Engineer based in Sonipat. Over the past year, I've been diving into the world of web applications, combining my love for design and functionality. I enjoy the magic of coding, where each line tells a unique story. Whether it's crafting front-end designs or navigating back-end intricacies, coding is my way of bringing ideas to life. Looking forward to more exciting coding journeys ahead.
             
            </p>
          </Col>
          <Col md={4} className="myAvtar" >
            <Tilt>
              <img src="./meenu.jpeg" style={{borderRadius:"50%", transform:"scale(0.8)" ,height:"300px"}} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
         <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
            
              <li className="social-icons">
              <a
                  href="https://www.linkedin.com/in/meenukat/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a> 
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/MeenuKatariya"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
            </ul>
          </Col>
        </Row> 
      </Container> 
    </Container>
  );
}
export default Home2;
